import {Box, Stack, Typography} from '@mui/material';
import InfoTip from 'src/components/ui/InfoTip';
import {formatAmountString} from 'src/utils/moneyUtils';
import {getProfitTip, getStockValueTip} from './inventory-profit-tips';

export default function InventoryProfitSummary({summary}) {
	const {soldQuantity, revenue, cost, profit, stockValue, isEstimated} = summary;
	const hasCost = profit !== null;
	const isLoss = hasCost && profit < 0;

	return (
		<Box mt={2}>
			<Stack direction="row" flexWrap="wrap" gap={1.5}>
				<ProfitStat label="الكمية المباعة" value={soldQuantity} />
				<ProfitStat label="المبيعات" value={formatAmountString(revenue)} />
				{hasCost && <ProfitStat label="تكلفة المباع" value={formatAmountString(cost)} />}
				{hasCost && (
					<ProfitStat
						label={isLoss ? 'الخسارة' : 'الربح'}
						value={formatAmountString(Math.abs(profit))}
						color={isLoss ? 'error.main' : 'success.main'}
						tip={getProfitTip(summary)}
					/>
				)}
				{stockValue !== null && (
					<ProfitStat
						label={`قيمة المخزون غير المباع`}
						value={formatAmountString(stockValue)}
						tip={getStockValueTip(summary)}
					/>
				)}
			</Stack>
			{!hasCost && (
				<Typography variant="caption" color="text.secondary">
					لا يمكن حساب الربح: لا توجد مشتريات لهذا المنتج لمعرفة التكلفة
				</Typography>
			)}
			{isEstimated && (
				<Typography variant="caption" color="text.secondary">
					الأرقام تقريبية: بعض الكميات ليس لها مشتريات مسجلة، تم استخدام آخر تكلفة شراء معروفة
				</Typography>
			)}
		</Box>
	);
}

function ProfitStat({label, value, tip, color = 'text.primary'}) {
	return (
		<Box sx={{px: 2, py: 1, borderRadius: 1, bgcolor: 'background.neutral', minWidth: 120}}>
			<Stack direction="row" alignItems="center" justifyContent="space-between" minHeight={26}>
				<Typography variant="caption" color="text.secondary">
					{label}
				</Typography>
				{tip && (
					<InfoTip
						mb={0}
						title={tip.map((line) => (
							<Box key={line} my={0.5}>
								{line}
							</Box>
						))}
					/>
				)}
			</Stack>
			<Typography variant="subtitle1" color={color}>
				{value}
			</Typography>
		</Box>
	);
}
